import { mapState, mapActions } from 'vuex';

export default {
  name: 'SetUnreadBtn',

  data() {
    return {
      isSetUnread: false,
    };
  },

  computed: {
    ...mapState('QA/Question', {
      ms_qaQuestion: 'qaQuestion',
    }),
  },

  methods: {
    ...mapActions('QA/Question', {
      ma_setQuestionUnread: 'setQuestionUnread',
    }),

    async setQuestionUnread() {
      if (!this.isSetUnread) {
        await this.ma_setQuestionUnread({
          qaQuestionId: this.ms_qaQuestion.qaQuestionId,
        });
        this.isSetUnread = true;
      }
    },
  },
};
